import { Button, Modal } from 'antd'

const MemberAttributeEditAlertModal = ({
	memberAttribute,
	showMemberAttributeDetailModal,
	visible,
	onClose,
}) => {
	return (
		<Modal open={visible} closable={false} footer={null} centered width={400}>
			<div style={{ textAlign: 'left' }}>
				<p style={{ color: 'black' }}>
					「選択肢」の変更、追加、削除を行うと、すでに回答済みの情報がリセット（削除）されます。編集の際はご注意ください。
				</p>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						marginTop: '15px',
					}}
				>
					<Button
						onClick={() => {
							showMemberAttributeDetailModal(memberAttribute)
							onClose()
						}}
						style={{
							border: '1px solid red',
							color: 'red',
							backgroundColor: 'transparent',
							borderRadius: '0px',
						}}
					>
						編集を続ける
					</Button>
					<Button
						style={{
							border: '1px solid black',
							color: 'black',
							backgroundColor: 'transparent',
							borderRadius: '0px',
						}}
						onClick={onClose}
					>
						閉じる
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default MemberAttributeEditAlertModal
